// extracted by mini-css-extract-plugin
module.exports = {"arrow-container":"styles__arrow-container___2xe5C","visible":"styles__visible___2Avev","button":"styles__button___2vDdU","icon":"styles__icon___3MLpg"};